import React from 'react';

import Modal from '../../../common/modal/Modal';
import { SaveButton } from '../../../common/button/save-button/SaveButton';

export const RemoveEnrolmentScheduleModal = ({ closeModal, handleConfirmRemoveSchedule }) => {
  return (
    <Modal
      closeModal={closeModal}
      setIsModalOpen={closeModal}
      headerTitle="Remove Schedule"
      hideButton
      width="540px"
      height="max-content"
      contentPadding="20px"
      justifyContent="center"
    >
      <div className="visit-pack-warning-modal">
        <p className="visit-pack-warning-modal-message">
          You are removing the schedule that currently contains the enrolment visit.
        </p>
        <p className="visit-pack-warning-modal-message">
          If you continue, a new schedule tab will be created so you can recreate the enrolment visit schedule.
        </p>

        <div className="visit-pack-warning-modal-buttons">
          <SaveButton
            color="#ffffff"
            border="1px solid #6f8695"
            textColor="#6f8695"
            title="Cancel"
            onClick={closeModal}
          />
          <SaveButton
            color="#6f8695"
            border="1px solid #6f8695"
            textColor="#ffffff"
            title="Continue"
            onClick={handleConfirmRemoveSchedule}
          />
        </div>
      </div>
    </Modal>
  );
};
